import { useQuery } from "@apollo/client";
import { Box, CircularProgress } from "@mui/material";
import { ReactElement } from "react";

import {
  GetSubaccountShortcodeQuery,
  GetSubscriberSummaryQuery,
  GetSubscriberSummaryQueryVariables,
} from "~frontend/__generated__/graphql";
import { FlexBox } from "~frontend/components/FlexBox";
import { GET_SUBSCRIBER_SUMMARY } from "~frontend/graphql/shortcode";

export function AudienceSummary({
  shortcode,
}: {
  shortcode: GetSubaccountShortcodeQuery["getSubaccount"]["shortcode"];
}): ReactElement {
  const summaryQuery = useQuery<
    GetSubscriberSummaryQuery,
    GetSubscriberSummaryQueryVariables
  >(GET_SUBSCRIBER_SUMMARY, {
    variables: {
      input: {
        shortcodeId: shortcode!.id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (summaryQuery.loading) {
    return (
      <>
        <CircularProgress size={16} />
        Loading subscriber summary...
      </>
    );
  }

  if (summaryQuery.error) {
    return <>Error loading subscriber summary</>;
  }

  return (
    <FlexBox gap={3}>
      <Box>
        {summaryQuery.data!.getSubscriberSummary.activeSubscribers} Active
        Subscribers
      </Box>
      <Box>
        {summaryQuery.data!.getSubscriberSummary.unsubscribedSubscribers}{" "}
        Unsubscribed
      </Box>
    </FlexBox>
  );
}
